import { IconButton, Skeleton } from "@mui/material";

// Icons
import ArrowForwardIosRoundedIcon from "@mui/icons-material/ArrowForwardIosRounded";

interface ICollapsibleProps {
	collapsible?: boolean;
	loading?: boolean;
	collapsed: boolean;
	handleExpandToggle: () => void;
}

const CollapsibleButton = (props: ICollapsibleProps) => {
	const { collapsible, loading, collapsed, handleExpandToggle } = props;
	if (!collapsible) {
		return null;
	}
	return (
		<>
			{loading ? (
				<Skeleton variant="circular" width={35} height={35} sx={{ marginLeft: "10px" }} />
			) : (
				<IconButton size="small" aria-label="expand" className="section-container-expand-btn" onClick={handleExpandToggle}>
					<ArrowForwardIosRoundedIcon className={collapsed ? "arrow-icon-point-down" : "arrow-icon-point-up"} />
				</IconButton>
			)}
		</>
	);
};

export default CollapsibleButton;
